import React from 'react'
import { Helmet } from 'react-helmet'
import utils from '../utils'
import HomeTopBar from '../components/home/HomeTopBar'
import CategoryList from '../components/categories/CategoryList'
import HomeCategories from '../components/home/HomeCategories'
import Featured from '../components/home/Featured'
import CategoryProducts from '../components/home/CategoryProducts'
import Carousel from '../components/home/Carousel'
import Search from '../components/nav/Search'
import { MdSupportAgent, MdVerifiedUser, MdLocalShipping, MdWorkspacePremium, MdAssignmentReturn } from 'react-icons/md';

function HomePage() {
    return (
        <div>
            <Helmet>
                <title>Home - {utils.siteName}</title>
            </Helmet>
            <div className='md:hidden sticky top-[54px] bg-white z-10 px-1'>
                <Search />
            </div>
            <HomeTopBar />
            <section className="bg-neutral py-12 border-t border-white/5 mb-3">
                <div className="px-4 md:px-8 grid grid-cols-2 md:grid-cols-5 gap-8 text-center md:text-left">
                    <div className="flex flex-col md:flex-row items-center gap-4">
                        <MdSupportAgent className="text-secondary text-3xl" />
                        <div>
                            <p className="text-white font-semibold text-base">24/7 Support</p>
                            <p className="text-neutral-content text-xs">Always here to help</p>
                        </div>
                    </div>
                    <div className="flex flex-col md:flex-row items-center gap-4">
                        <MdVerifiedUser className="text-secondary text-3xl" />
                        <div>
                            <p className="text-white font-semibold text-base">Secure Payments</p>
                            <p className="text-neutral-content text-xs">M-Pesa, Visa & More</p>
                        </div>
                    </div>
                    <div className="flex flex-col md:flex-row items-center gap-4">
                        <MdLocalShipping className="text-secondary text-3xl" />
                        <div>
                            <p className="text-white font-semibold text-base">Fast Delivery</p>
                            <p className="text-neutral-content text-xs">Nationwide shipping</p>
                        </div>
                    </div>
                    <div className="flex flex-col md:flex-row items-center gap-4">
                        <MdWorkspacePremium className="text-secondary text-3xl" />
                        <div>
                            <p className="text-white font-semibold text-base">Authentic Brands</p>
                            <p className="text-neutral-content text-xs">100% Genuine Items</p>
                        </div>
                    </div>
                    <div className="flex flex-col md:flex-row items-center gap-4 col-span-2 md:col-span-1">
                        <MdAssignmentReturn className="text-secondary text-3xl" />
                        <div>
                            <p className="text-white font-semibold text-base">Easy Returns</p>
                            <p className="text-neutral-content text-xs">Hassle-free process</p>
                        </div>
                    </div>

                </div>
            </section>
            <div className="space-y-5 container mx-auto px-2">
                <Featured />
                <HomeCategories />
                <CategoryProducts />
            </div>
            <div>
                <Carousel />
            </div>
            <div className="space-y-5 container mx-auto px-2">
                <CategoryList isHome={1} />
            </div>
        </div>
    )
}

export default HomePage